//@ts-check
import React from "react";
import { endPoint } from "src/AppConstants";
import { v4 as uuid } from 'uuid'
import UserImg from "components/UserImg";

/**
 * 
 * @param {{ sendEmailVerification: (i:number)=> void, userData: import('./User').UserDetailDto , t: import('features/language/languageService').LanguageService}} props 
 */
const UserDataReadOnly = ({ userData, t, sendEmailVerification }) => {

    const userImage = endPoint.GET_USER_IMAGE_URL(userData.Id) + `?x=${uuid()}`;

    return (

        <div className="mb-5">


            <div className="row">
                <div className="col-sm-3 col-md-2">
                    <UserImg src={userImage} className="" alt={t.getText('user')} />
                </div>
                <div className="col-sm-9 col-md-10">

                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-3">
                            <ReadOnlyData val={userData.Info.FirstName} label={t.getText("firstname")} />
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                            <ReadOnlyData val={userData.Info.LastName} label={t.getText("lastname")} />
                        </div>
                        {(userData.Info.Email.Address && userData.Info.Email.Address.length > 0) &&
                            <div className="col-lg-4 col-md-6 mb-3">
                                <ReadOnlyData val={userData.Info.Email.Address} label={t.getText("mail")} />

                                {!userData.Info.Email.Verified && <>
                                    <button type="button" onClick={() => sendEmailVerification(1)} className="btn btn-inverse btn-small mr-3 mb-3">{t.getText("send.verification.email")}</button>
                                </>}

                            </div>
                        }
                    </div>

                    <div className="row mb-4">
                        {userData.Info.Properties.map(p => {
                            if (p.Value === null || p.Value === "") return null;
                            return <div key={p.Key} className="col-lg-4 col-md-6 mb-3">
                                <ReadOnlyData val={p.Value} label={t.getText(p.Key)} />
                            </div>
                        })}

                    </div>

                </div>
            </div>
        </div>

    )

}

/**
 * 
 * @param {{val: string, label: string }} props 
 */
const ReadOnlyData = ({ val, label }) => {

    return <>
        <div className="mb-2" >{label}</div>
        <div className="preserve-white alert alert-light">{val}</div>
    </>;
}


export default UserDataReadOnly;

